import { DayCellMountArg } from '@fullcalendar/core';

export function setWeekendColors(info: DayCellMountArg, color: string = '#EBEBEB') {
    if (info.date.getDay() === 6 || info.date.getDay() === 0) {
        info.el.style.backgroundColor = color;
    }
}
